import React, { type ReactNode, forwardRef, useState } from 'react'
import { TextArea, fontSize, spacing } from '@retailer-platform/shared-components'
import { css } from '@emotion/react'
import { useDashMessage } from 'intl/intl.hooks'
import { type DashMessages } from 'intl/intl.types'
import { MerchandisingFormInputWrapper } from './MerchandisingFormInputWrapper'

export interface Props extends Omit<React.HTMLProps<HTMLTextAreaElement>, 'name' | 'as'> {
  identifier: string
  labelId?: DashMessages
  labelPrefix?: ReactNode
  showLength?: boolean
}

const styles = css({
  height: 140,
  marginBottom: spacing.X4,
  paddingTop: spacing.X20,
  fontSize: fontSize.X15,
})

export const MerchandisingFormTextArea = forwardRef<HTMLTextAreaElement, Props>(
  (
    {
      maxLength,
      labelId,
      labelPrefix = '',
      onChange,
      identifier,
      defaultValue = '',
      showLength,
      ...rest
    },
    ref
  ) => {
    const label = labelPrefix + useDashMessage(labelId)

    const [value, setValue] = useState(defaultValue)

    const onTextChange = event => {
      onChange && onChange(event)
      setValue(event.target.value)
    }

    return (
      <MerchandisingFormInputWrapper
        label={label}
        showLength={showLength}
        maxLength={maxLength}
        value={value as string}
      >
        <TextArea
          {...rest}
          ref={ref}
          maxLength={maxLength}
          onChange={onTextChange}
          placeholder={label}
          name={identifier}
          css={styles}
        />
      </MerchandisingFormInputWrapper>
    )
  }
)
